module.exports = __webpack_public_path__ + "static/media/branding-logo-topbar.3b51037b.png";